module.exports = __webpack_public_path__ + "imgs/src/assets/imgs/battle//ready_top.jpg?v=234da66d";